var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-title-page"},[_c('div',{staticClass:"flex-grow-1 title-page"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"header-buttons"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }